import type { ComponentProps } from 'react'
import CitationResults from '@/app/(app)/tools/ai-citation-tracker/components/CitationResults'
import type { ToolDetailProps } from './detailRegistry'

/**
 * Dashboard detail renderer for `citation` (Phase 3, Step 12 — Class B,
 * dashboard-reuse). This REPLACES the legacy inline `citation` branch that
 * lived in `ToolDetailPanel` (a thin per-provider mention-rate grid).
 *
 * REUSES the public `CitationResults` with `variant="dashboard"`, which hides
 * the public-only chrome (the email-share row, PlatformCTA, and the gradient
 * services CTA). The platform route (`/api/platform/tools/citation-check`) runs
 * the same lib and returns the same `CitationCheckResult`, so the dashboard
 * `data` maps straight onto the component — the dashboard now shows the full
 * rich report (score ring + partial-scan banner, the provider grid with
 * per-provider cards, AI analysis, the score-breakdown cards with their
 * `findingsFor` per-category bullet lists, the query matrix with per-provider
 * columns, and recommendations with their blog links) instead of the generic
 * panel.
 *
 * Wrapped in `id="tool-detail-panel"` so the dashboard scroll-to-panel still
 * works. Grade comes from `data.grade` via the reused component — never
 * recomputed; the deleted generic deriveBreakdown is NOT reintroduced (the
 * reused renderer owns the breakdown). Render-layer only.
 */
export function CitationDashboardDetail({ data }: ToolDetailProps) {
  const result = data as unknown as ComponentProps<
    typeof CitationResults
  >['result']
  return (
    <div
      id='tool-detail-panel'
      className='rounded-xl border border-border bg-card p-5'
    >
      <CitationResults result={result} variant='dashboard' />
    </div>
  )
}
